import { useSignal } from '@preact/signals'

import { HorizontalDivider, Typography } from 'components'

import { members } from './members_mock'
import { resetFormAndErrors } from './state'
import {
	MembersTable,
	AdquireAdditionalSeatButton,
	RemoveMemberModal,
	AddMemberModal
} from './components'

const TeamInfoPage = () => {
	const isRemoveMemeberModalOpen = useSignal(false)
	const isAddMemberModalOpen = useSignal(false)
	const memberForRemove = useSignal('')

	const handleOpenRemoveMemberModal = (memberUsername: string) => {
		isRemoveMemeberModalOpen.value = true
		memberForRemove.value = memberUsername
	}

	const handleCloseRemoveMemberModal = () => {
		isRemoveMemeberModalOpen.value = false
		memberForRemove.value = ''
	}

	const handleOpenAddMemberModal = () => {
		isAddMemberModalOpen.value = true
	}

	const handleCloseAddMemberModal = () => {
		isAddMemberModalOpen.value = false
		resetFormAndErrors()
	}

	return (
		<>
			<div class='flex grid-cols-1 flex-col-reverse gap-10 xl:grid xl:grid-cols-[2fr_1fr]'>
				<div class='flex-1'>
					<Typography color='text-black-100' text='Testing' variant='h3' />
					<Typography
						class='mt-2'
						color='text-black-200'
						text='Here you can easily create, manage, and work together with your team in one place.'
						variant='text1'
					/>

					<HorizontalDivider className='my-16 xl:my-10' />

					<MembersTable
						handleOpenRemoveMemberModal={handleOpenRemoveMemberModal}
						members={members}
					/>
				</div>

				<div>
					<AdquireAdditionalSeatButton
						handleOpenAddMemberModal={handleOpenAddMemberModal}
					/>
				</div>
			</div>

			<RemoveMemberModal
				isModalOpen={isRemoveMemeberModalOpen}
				isRemoveMemberButtonDisabled={false}
				isRemoveMemberButtonLoading={false}
				memberUsername={memberForRemove}
				onCloseRemoveMemberModal={handleCloseRemoveMemberModal}
				removeMember={handleCloseRemoveMemberModal}
			/>
			<AddMemberModal
				addMember={handleCloseAddMemberModal}
				closeAddMemberModal={handleCloseAddMemberModal}
				isModalOpen={isAddMemberModalOpen}
			/>
		</>
	)
}

export { TeamInfoPage }
